/* eslint-disable no-undef */
import Vuex from 'vuex'
import Vue from 'vue'

import AuthService from '../services/AuthService'
import PostService from '../services/PostService'
import CompanyService from '../services/CompanyService'
import UserService from '../services/UserService'
import Util from '../services/UtilService'
import router from '../router'
import lang from './modules/lang'
import to from 'await-to-js'

const moment = require('moment')
Vue.use(require('vue-moment'), { moment })

Vue.use(Vuex)

export default new Vuex.Store({
  // strict: true,
  modules: {
    lang
  },
  state: { // = data
    demo: false,
    mode: 'wifi',
    vendor: 'unifi',
    authUrl: '',
    token: '',
    iconRedirect: '/login',
    buttonRedirect: '/login',
    offset: 0,
    amount: 10,
    ap: '',
    device: {
    },
    user: {
    },
    company: {
    },
    config: {
    },
    firstPost: false,
    companyPosts: [],
    promoPosts: [],
    giftPosts: [],
    initialized: false,
    loading: true,
    urlUserMac: '',
    urlApMac: ''
  },
  getters: { // = computed properties
    loggedIn(state) {
      return state.device.status === 'V'
    },
    viewport() {
      let e, a
      e = window
      a = 'inner'
      if (!('innerWidth' in window)) {
        a = 'client'
        e = document.documentElement || document.body
      }
      return { width: e[a + 'Width'], height: e[a + 'Height'] }
    },
    codeDestination(state) {
      if (!Util.isEmpty(state.user) && state.user !== undefined && state.user !== null) {
        return (state.route.params.type === 'sms' || state.route.params.type === 'whatsapp') ? state.user.phone : state.user.email
      } else {
        return ''
      }
    },
    appLang(state) {
      return (Util.isEmpty(state.user) || state.user === undefined || state.user === null) ? state.company.LanguageId || 1 : state.user.LanguageId || 1
    },
    langShortcut(state, getters) {
      switch (getters.appLang) {
        case 1: {
          return 'en'
        }
        case 2: {
          return 'de'
        }
        case 3: {
          return 'sr'
        }
      }
    },
    home(state) {
      return '/'
      // return '/guest/s/' + state.company.site + '/?id=' + state.device.mac + '&ap=' + state.ap
    },
    landingPage(state) {
      return (state.config.promo_page) ? state.config.promo_page : '//www.google.com'
    },
    fbLogin(state) {
      return 'https://www.facebook.com/v7.0/dialog/oauth?client_id=1004863898709418&state={"token":"' + state.token + '","ap":"' + state.ap + '","vendor":"' + state.vendor + '","oauth":"facebook"}&response_type=code%20granted_scopes&scope=email&redirect_uri=' + process.env.APP_ROOT + '/login'
    },
    feedPosts(state) {
      let posts = []
      let companyPosts = state.companyPosts.filter((e) => e.id !== state.firstPost.id)
      let feedPosts = companyPosts.concat(state.promoPosts)
      posts = Util.shuffle(feedPosts)
      return posts
    }
  },
  // Can be complex but never update the state (That's mutations job!)
  actions: {
    async fetchPosts({ state, commit }) {
      const [err, response] = await to(CompanyService.getAllPosts(state.company.id, {
        offset: 0,
        amount: state.config.posts_amount
      }))
      if (err) return this._vm.errorHandler(err)
      commit('setCompanyPosts', response.data.posts)
      commit('setFirstPosts', response.data.posts[0])
      if (!state.config.only_own_posts) {
        const [err, response] = await to(PostService.getPromoPosts({
          countryId: state.company.CountryId,
          offset: 0,
          amount: state.amount - state.config.posts_amount,
          excludeCompany: state.company.id
        }))
        if (err) return this._vm.errorHandler(err)
        if (response.data.status && response.data.promoPosts.length > 0) {
          commit('setPromoPosts', response.data.promoPosts)
        }
      }
      if (state.mode === 'gift') {
        const [err, response] = await to(PostService.getGiftPosts({
          offset: 0,
          amount: 1,
          CompanyId: state.company.id
        }))
        if (err) return this._vm.errorHandler(err)
        if (response.data.success) {
          commit('setGiftPosts', response.data.giftPosts)
        }
      }
    },
    async login({ state, commit, getters }, params = { mode: 'wifi' }) {
      let err, response
      if (params.mode === 'wifi') {
        commit('setVendor', (state.route.query.vendor) ? state.route.query.vendor : 'unifi');
        [err, response] = await to(AuthService.login({
          mode: params.mode,
          width: this.getters.viewport.width,
          height: this.getters.viewport.height,
          demo: state.demo,
          mac: state.urlUserMac,
          ap: state.urlApMac,
          site: state.route.params.site,
          vendor: state.vendor
        }))
      } else if (params.mode === 'gift') {
        [err, response] = await to(AuthService.login({
          mode: params.mode,
          width: this.getters.viewport.width,
          height: this.getters.viewport.height,
          key: params.key,
          UserId: this._vm.$cookies.get('UserId'),
          DeviceId: this._vm.$cookies.get('DeviceId'),
          demo: state.demo,
          CompanyId: params.CompanyId
        }))
      }

      if (err) return this._vm.errorHandler(err)
      commit('setMode', params.mode)
      commit('setToken', response.data.token)
      commit('setUser', response.data.user)
      commit('setCompany', response.data.company)
      commit('setDevice', response.data.device)
      commit('setConfig', response.data.company.config)
      commit('setAp', response.data.ap)
      commit('setInitialize', true)
      // Browser language detection on first login
      if (response.data.user === undefined || response.data.user === null) {
        commit('setLang', Util.getFirstBrowserLanguage().slice(0, 2))
      } else {
        commit('setLang', getters.langShortcut)
      }

      // Auto-login - Full auth after click in email - Radius case
      if (state.route.query.vendor === 'mikrotik' && state.route.query.autologin === 'true') {
        router.push({ path: '/authorize' })
      }
    },
    async register({ state, commit }, data) {
      const [err, response] = await to(AuthService.register(data))
      if (err) return err.response.data.error
      if (response.data.success) {
        commit('setUser', response.data.user)
        return true
      } else return response.data.error
    },
    async social({ state, commit, rootState }, data) {
      const [err, response] = await to(AuthService.social(data))
      if (err) return this._vm.errorHandler(err)
      if (response.data.success) {
        commit('setUser', response.data.user)
        router.push({ path: `/verify/${data.verify.type}` })
      } else this.errorSnack(rootState.lang[this.appLang].ERROR)
    },
    async reset({ state, commit, rootState }) {
      const [err, response] = await to(AuthService.reset())
      if (err) return this._vm.errorHandler(err)
      if (response.data.success) {
        router.push({ path: `/guest/s/${state.company.site}/?id=${state.device.mac}&ap=${state.ap}&vendor=${state.vendor}` })
        commit('setDevice', {})
        commit('setToken', '')
        commit('setInitialize', false)
      } else this.errorSnack(rootState.lang[this.appLang].ERROR)
    },
    async adInteraction({ state, commit, getters, rootState }, data) {
      const [err, response] = await to(PostService.interaction(data))
      if (err) return this._vm.errorHandler(err)
      if (!response.data.success) this.errorSnack(rootState.lang[this.appLang].ERROR)
    },
    async adInteractionDislike({ state, commit, getters, rootState }, data) {
      const [err, response] = await to(PostService.adInteractionDislike(data))
      if (err) return this._vm.errorHandler(err)
      if (!response.data.success) this.errorSnack(rootState.lang[this.appLang].ERROR)
    },
    async changeLang({ state, commit, rootState }, data) {
      commit('setLang', data)
      if (!Util.isEmpty(state.user) && state.user !== undefined && state.user !== null) {
        const [err, response] = await to(UserService.updateLang(state.user.id, { LanguageId: state.user.LanguageId }))
        if (err) return this._vm.errorHandler(err)
        if (!response.data.success) this.errorSnack(rootState.lang[this.appLang].ERROR)
      }
    }
  },
  mutations: {
    setMode(state, mode) {
      state.mode = mode
    },
    setUrlUserMac(state, mac) {
      state.urlUserMac = mac
    },
    setUrlApMac(state, mac) {
      state.urlApMac = mac
    },
    setAuthUrl(state, authUrl) {
      state.authUrl = authUrl
    },
    setVendor(state, vendor) {
      state.vendor = vendor
    },
    setCompanyPosts(state, companyPosts) {
      state.companyPosts = companyPosts
    },
    setFirstPosts(state, firstPost) {
      state.firstPost = firstPost
      state.firstPost.payload.swiper.autoplay = {
        delay: 4500,
        disableOnInteraction: false
      }
    },
    setPromoPosts(state, promoPosts) {
      state.promoPosts = promoPosts
    },
    setGiftPosts(state, giftPosts) {
      state.giftPosts = giftPosts
    },
    setToken(state, token) {
      state.token = token
    },
    setUser(state, user) {
      if (user) this._vm.$cookies.set('UserId', user.id)
      state.user = user
    },
    setCompany(state, company) {
      state.company = company
    },
    setDevice(state, device) {
      if (device) this._vm.$cookies.set('DeviceId', device.id)
      state.device = device
    },
    setLang(state, lang) {
      let langId
      switch (lang) {
        case 'en': {
          langId = 1
          let locale = require('moment/locale/en-gb')
          moment.updateLocale('en-gb', locale)
          break
        }
        case 'de': {
          langId = 2
          let locale = require('moment/locale/de')
          moment.updateLocale('de', locale)
          break
        }
        case 'sr': {
          langId = 3
          let locale = require('moment/locale/sr')
          moment.updateLocale('sr', locale)
        }
      }
      if (Util.isEmpty(state.user) || state.user === undefined || state.user === null) {
        state.company.LanguageId = langId
      } else {
        state.user.LanguageId = langId
      }
    },
    setInitialize(state, initialized) {
      state.initialized = initialized
    },
    setLoading(state, loading) {
      state.loading = loading
    },
    setAp(state, ap) {
      state.ap = ap
    },
    setButtonRedirect(state, redirect) {
      state.buttonRedirect = redirect
    },
    setConfig(state, config) {
      state.config = config
      if ((state.user !== undefined && state.user !== null && config.login_on_visits >= state.user.visits) || !config.login_option) {
        state.buttonRedirect = '/authorize'
        state.iconRedirect = '/user'
      } else {
        switch (state.device.status) {
          case 'N': {
            state.iconRedirect = '/login'
            state.buttonRedirect = '/login'
            break
          }
          case 'V': {
            state.iconRedirect = '/user'
            if (state.mode === 'wifi') {
              state.buttonRedirect = '/authorize'
            } else if (state.mode === 'gift') {
              state.buttonRedirect = '/gift'
            }
            break
          }
          case 'P': {
            state.iconRedirect = '/verify/sms'
            state.buttonRedirect = '/verify/sms'
            break
          }
          case 'E': {
            state.iconRedirect = '/verify/email'
            state.buttonRedirect = '/verify/email'
            break
          }
        }
      }
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/store.js